// extracted by mini-css-extract-plugin
export default {"menuOption":"menu-option_menuOption__-6i-k","icon":"menu-option_icon__79-fF","label":"menu-option_label__CTEWG"};